import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import React from 'react';
import TranslationUtils from 'Utils/TranslationUtils';

import PiplSearchLogo from '../../../Components/PiplSearchLogo';
import Form from './ExistingCustomerVettingForm';
import LeadVettingLogic from './ExistingCustomerVettingLogic';
import './ExistingCustomerVettingStyle.less';
import { trackEvent } from '../utils';

import styles from './ExistingCustomerVettingFormStyles.module.less';

class ExistingCustomerVettingPage extends React.Component {
  componentDidMount() {
    trackEvent('open', '');
  }

  _onFirstBlur = () => {};

  _isUserOrgAdmin = () => {
    return this.props.user.is_org_admin || false;
  };

  render() {
    return (
      <div className={styles.leadVettingPageContainer}>
        <Helmet>
          <title>{gettext('Vetting is required')}</title>
        </Helmet>
        <PiplSearchLogo />
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div className={styles.headerWrapper}>
            <div className={styles.pageTitle}>
              <span style={{ textAlign: 'center' }}>
                {this._isUserOrgAdmin()
                  ? TranslationUtils.getText('EXISTING_CUSTOMER_VETTING_MAIN_TITLE')
                  : TranslationUtils.getText('EXISTING_CUSTOMER_NOT_ADMIN_VETTING_MAIN_TITLE')}
              </span>
            </div>
            <div className={styles.pageParagraph}>
              <span style={{ textAlign: 'center' }}>
                {this._isUserOrgAdmin()
                  ? TranslationUtils.getText('EXISTING_CUSTOMER_VETTING_DESCRIPTION')
                  : TranslationUtils.getText('EXISTING_CUSTOMER_NOT_ADMIN_VETTING_DESCRIPTION')}
              </span>
            </div>
          </div>
          <div className={styles.formWrapper}>
            {this._isUserOrgAdmin() ? (
              <LeadVettingLogic {...this.props}>
                {(formProps) => {
                  return (
                    <Form
                      {...formProps}
                      isLoading={this.props.isLoading}
                      error={this.props.error}
                      product={this.props.product}
                    />
                  );
                }}
              </LeadVettingLogic>
            ) : (
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <span style={{ textAlign: 'center' }}>
                  {TranslationUtils.getText('EXISTING_CUSTOMER_NOT_ADMIN_VETTING_FOOTER')}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ExistingCustomerVettingPage.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.string,

  show: PropTypes.bool,
  hide: PropTypes.func,
  product: PropTypes.string,
  user: PropTypes.object,
};

export default ExistingCustomerVettingPage;
